'use client';

import { forwardRef } from 'react';
import MuiButton, { type ButtonProps as MuiButtonProps } from '@mui/material/Button';

export interface ButtonProps extends MuiButtonProps {
  loading?: boolean;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(({ loading, disabled, children, ...props }, ref) => {
  return (
    <MuiButton ref={ref} disabled={disabled || loading} {...props}>
      {loading ? 'Loading...' : children}
    </MuiButton>
  );
});

Button.displayName = 'Button';
